export default __webpack_public_path__ + "static/media/members.15eebee8.svg";